<template>

    <section class="dd-m-onboarding dd-m-onboarding-tutorial dd-m-onboarding-tutorial--android"
             v-if="show">
        <div class="dd-m-onboarding-tutorial__wrapper">
            <article class="dd-m-onboarding-tutorial__item">
                <header class="dd-m-onboarding-tutorial__header dd-m-text-semibold">
                    <h3 class="dd-m-onboarding-tutorial__title dd-m-text-bold">
                        TÁ GOSTANDO DO PERFUMATCH?—
                    </h3>

                    <p>
                        Instale o App e descubra ainda mais!
                    </p>

                    <footer class="dd-m-onboarding__footer-end dd-m-onboarding__footer-end--custom">
                        <button type="button" class="dd-m-button dd-m-button--assertive"
                                v-if="step !== 3"
                                v-on:click.prevent="next">
                            Next
                        </button>

                        <button type="button" class="dd-m-button dd-m-button--assertive"
                                v-if="step === 3"
                                v-on:click.prevent="close">
                            Ok
                        </button>
                    </footer>
                </header>

                <div class="dd-m-onboarding-tutorial__content" v-bind:class="{'dd-last' : step === 3}">
                    <Slick ref="slick" :options="options" @beforeChange="handleBeforeChange">
                        <picture v-for="(item, index) in [1, 2, 3, 4]"
                                 :key="index">
                            <source :srcset="'/assets/site/images/tutorial/android/0'+item+'-tablet.png'"
                                    media="(min-width: 768px)">
                            <img :src="'/assets/site/images/tutorial/android/0'+item+'.png'"
                                 :alt="'TÁ GOSTANDO DO PERFUMATCH?—' + item">
                        </picture>
                    </Slick>
                </div>
            </article>
        </div>
    </section>

</template>
<script>
    import items from '../data/onboarding.json';
    import SlickOptions from "../providers/slick";
    import Slick from "vue-slick";

    export default {
        name: 'onboarding-tutorial-android',
        components: {Slick},
        data: () => {
            return {
                list: [],
                options: new SlickOptions().getSimple(),
                show: false,
                step: 0
            }
        },
        mounted() {
            this.list = items;
            this.count();
        },
        methods: {
            count() {
                const os = MobileDetect.os();
                if (os === 'AndroidOS') {
                    const count = localStorage.android ? parseInt(localStorage.android) + 1 : 1;
                    if (count <= 3) localStorage.android = count;
                    this.display();
                }
            },
            display() {
                if (!localStorage.onboardingAndroidHasShown && localStorage.onboardingHasShown &&
                    localStorage.android == 3 && localStorage.hasAccessedOnceAQuiz) {
                    this.show = true;
                    localStorage.onboardingAndroidHasShown = true;
                }
            },
            handleBeforeChange(event, slick, currentSlide, nextSlide) {
                this.step = nextSlide;
            },
            close() {
                this.show = false;
            },
            next() {
                this.$refs.slick.next();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/onboarding-tutorial-android.vue